<template>
  <LoadingOverlay v-if="loading">
    <template v-slot:heading>
      Authenticating, wait a second...
    </template>
  </LoadingOverlay>
</template>

<script>
  import Api from '../../../api';
  import {mapActions, mapGetters} from "vuex";
  import LoadingOverlay from "../LoadingOverlay";

  export default {
    name: "LinkedinCallback",
    components: {LoadingOverlay},
    data() {
      return {
        loading: false
      }
    },
    async created() {
      try {
        const {code, state} = this.$route.query;
        if (!code || !state) {
          await this.$router.push('/auth');
        } else {
          this.loading = true;
          const token = await this.getLinkedinAccessToken(code, state);
          await this.loginWithLinkedin(token);
          this.closeWindow();
          this.loading = false;
        }
      } catch (e) {
        // this.closeWindow();
        this.loading = false;
      }
    },
    computed: {
      ...mapGetters([
        'redirectAfterAuthUrl'
      ])
    },
    methods: {
      ...mapActions([
        'authenticate'
      ]),

      async getLinkedinAccessToken(code, state) {
        const {access_token} = await Api.getLinkedinAccessToken({
          redirect_uri: 'https://buildabox.co/auth/sign-in/linkedin',
          code,
          state
        });
        return access_token;
      },

      async loginWithLinkedin(access_token) {
        const authData = await Api.loginWithLinkedin({access_token});
        await this.authenticate(authData);
      },

      closeWindow() {
        setTimeout(window.close, 301)
      }
    }
  }
</script>

<style scoped>

</style>
